import React from 'react';
import ArrLineChart, {
  ArrLineChartData,
} from '../../../components/common/arr-linechart/ArrLineChart';
import '../Demo.scss';
import {Box, Typography} from '@mui/material';
import {Link} from 'react-router-dom';

const chartData: ArrLineChartData[] = [
  {xAxisData: 'Tue', yAxisData: 0},
  {xAxisData: 'Wed', yAxisData: 17},
  {xAxisData: 'Thu', yAxisData: 60},
  {xAxisData: 'Fri', yAxisData: 0},
  {xAxisData: 'Sat', yAxisData: 0},
  {xAxisData: 'Sun', yAxisData: 0},
  {xAxisData: 'Mon', yAxisData: 0},
];

const initData: ArrLineChartData[] = [
  {xAxisData: 'Tue', yAxisData: 0},
  {xAxisData: 'Wed', yAxisData: 0},
  {xAxisData: 'Thu', yAxisData: 0},
  {xAxisData: 'Fri', yAxisData: 0},
  {xAxisData: 'Sat', yAxisData: 0},
  {xAxisData: 'Sun', yAxisData: 0},
  {xAxisData: 'Mon', yAxisData: 0},
];

const LineChart: React.FC = () => {
  return (
    <Box className="select-dropdown">
      <h1>LineChart</h1>
      <Typography></Typography>
      <hr />
      <Link to="/demo" className="link">
        Return
      </Link>
      <hr />
      <div style={{width: '382px', height: '182px'}}>
        <ArrLineChart data={initData} title="Review Day" />
      </div>
      <div style={{width: '382px', height: '182px'}}>
        <ArrLineChart data={chartData} title="Review Day" />
      </div>
    </Box>
  );
};

export default LineChart;
